export const GET_POKEMONS = "GET_POKEMONS";
export const GET_POKEMON_NAME = "GET_POKEMON_NAME";
export const GET_POKEMONS_ID = "GET_POKEMONS_ID";
export const GET_TYPES = "GET_TYPES";
export const POST_POKEMONS = "POST_POKEMONS";
export const FILTER = "FILTER";
export const ORDER = "ORDER";
export const FILTER_BY_TYPES = "FILTER_BY_TYPES";
export const PAGE = "PAGE";
export const SET_LOADING = 'SET_LOADING';  
export const UNSET_LOADING = 'UNSET_LOADING';